export default __webpack_public_path__ + "images/3C.dc5325e.png";